module.exports = __webpack_public_path__ + "img/bg.467a3dfb.jpg";